export default __webpack_public_path__ + "static/bg-b78e79099a46df867b9313dfc9a94d47.png";